import { render, staticRenderFns } from "./BatchModifyLogo.vue?vue&type=template&id=551a0b8a&scoped=true"
import script from "./BatchModifyLogo.vue?vue&type=script&lang=js"
export * from "./BatchModifyLogo.vue?vue&type=script&lang=js"
import style0 from "./BatchModifyLogo.vue?vue&type=style&index=0&id=551a0b8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551a0b8a",
  null
  
)

export default component.exports